import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Sync as SyncIcon,
  People as PeopleIcon,
  CompareArrows as CompareArrowsIcon
} from '@mui/icons-material';

function ComponentSelector({ activeTab, onTabChange, direction }) {
  const navigate = useNavigate();

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    // Call the parent's onTabChange function
    onTabChange(newValue);

    // Navigate to the corresponding route with direction
    const directionPath = direction === 'erp-to-shopify' ? '/erp-to-shopify' : '/shopify-to-erp';

    switch (newValue) {
    case 0:
      navigate(`/customer-sync${directionPath}/operations`);
      break;
    case 1:
      navigate(`/customer-sync${directionPath}/customers`);
      break;
    case 2:
      navigate(`/customer-sync${directionPath}/mapping`);
      break;
    case 3:
      navigate(`/customer-sync${directionPath}/settings`);
      break;
    default:
      navigate(`/customer-sync${directionPath}/operations`);
    }
  };

  return (
    <Box>
      <Paper elevation={0} sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab icon={<SyncIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Operations" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<PeopleIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Customers" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<CompareArrowsIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Mapping" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
          <Tab icon={<SettingsIcon sx={{ fontSize: { xs: '20px', sm: '24px', md: '28px' }}} />} label="Settings" sx={{ fontSize: { xs: '10px', sm: '12px', md: '12px', lg: '16px' } }} />
        </Tabs>
      </Paper>
    </Box>
  );
}

export default ComponentSelector;
